import {Component, computed, inject, OnInit} from '@angular/core';
import {Fluid} from 'primeng/fluid';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {Checkbox} from 'primeng/checkbox';
import {
  CompanyControllerService,
  CompanyResponse,
  CreateUpdateProjectRequest,
} from '@frontend/shared-api';
import {CompanyOfficeFunctionSelectionService} from '../services/company-office-function-selection.service';
import {BaseStepComponent} from '../../../../../shared/components/wizard/base-step.component';

@Component({
  selector: 'app-project-wizard-company-step',
  imports: [Fluid, FormsModule, TranslocoDirective, ReactiveFormsModule, Checkbox],
  templateUrl: './project-wizard-company-step.component.html',
})
export class ProjectWizardCompanyStepComponent
  extends BaseStepComponent<CreateUpdateProjectRequest>
  implements OnInit
{
  override form: any;
  override stepIndex = 2;
  protected override isValidComputed = computed(() => {
    return this.isAtLeastOneCompanySelected();
  });

  private readonly companyController = inject(CompanyControllerService);
  private readonly companySelectionService = inject(CompanyOfficeFunctionSelectionService);

  companies: CompanyResponse[] = [];
  selectedCompanies: CompanyResponse[] = [];
  loading = false;

  override ngOnInit(): void {
    this.fetchCompanies();
    this.loadSelectedCompanies();
  }

  private isAtLeastOneCompanySelected(): boolean {
    return this.companySelectionService.selectedCompanyIds().size > 0; // need to call companySelectionService to trigger the effect
  }

  fetchCompanies(): void {
    this.loading = true;
    this.companyController.getAllCompanies().subscribe({
      next: (data: CompanyResponse[]) => {
        this.companies = data;
        this.companySelectionService.setCompaniesData(data);
        this.loading = false;
      },
      error: () => (this.loading = false),
    });
  }

  toggleCompany(id: number) {
    this.companySelectionService.toggleCompany(id);
  }

  loadSelectedCompanies() {
    this.selectedCompanies = this.companySelectionService.selectedCompanies() || [];
  }

  isCompanySelected(companyId: number): boolean {
    return this.selectedCompanies.some((company) => company.id === companyId);
  }
}
